<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn
          @click="handleOpenCreateEditPartnerModal"
          color="primary"
          target="_blank"
          elevation="0"
        >
          <v-icon left> mdi-plus </v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('partner.action.create') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <PartnerListFilters />

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="partners"
        :loading="isLoading"
        :items-per-page="30"
        @dblclick:row="showPartnerRow"
        :no-data-text="$t('transfer.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span>
            {{ item.name ? item.name : '---' }}
          </span>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <span>
            {{ item.description ? item.description : '---' }}
          </span>
        </template>
        <template v-slot:[`item.date_created`]="{ item }">
          <span>
            {{ item.date_created ? formatDate(item.date_created) : '---' }}
          </span>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                :class="{ linked: item.asaas_wallet_id }"
                :style="`background-image: url(${logoAsaas}`"
                :alt="item.asaas_wallet_id ? $t('partner.label.linked') : $t('partner.label.notLinked')"
                class="asaas"
              />
            </template>
            <span>
              {{
                item.asaas_wallet_id
                  ? $t('partner.label.linked')
                  : $t('partner.label.notLinked')
              }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-end">
            <v-btn @click="showPartner(item.id)" class="mx-2" icon small>
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
            <v-btn
              @click="handleOpenCreateEditPartnerModal(item.id)"
              class="mx-2"
              icon
              small
            >
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
            <v-btn
              @click="handleDeletePartnerModal(item.id)"
              class="mx-2"
              icon
              small
            >
              <v-icon small> mdi-delete </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchPartners" :requireOrderByFilter="false" />

    <RightDrawer :moreInfo="false">
      <PartnerDetails />
    </RightDrawer>

    <PartnerCreateUpdate />
    <PartnerDelete />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { headers } from './listHeaders/partnerHeaders'
import PartnerListFilters from '@/views/partner/components/PartnerListFilters'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import RightDrawer from '@/components/app/RightDrawer'
import PartnerDelete from '@/views/partner/components/PartnerDelete'
import PartnerCreateUpdate from '@/views/partner/components/PartnerCreateUpdate'
import PartnerDetails from '@/views/partner/components/PartnerDetails'
import logoAsaas from '@/assets/images/logo-asaas.svg'

export default {
  name: 'PartnerList',

  components: {
    PartnerListFilters,
    RightDrawer,
    PartnerDetails,
    PartnerCreateUpdate,
    PartnerDelete,
  },

  mounted() {
    this.fetchPartners()
  },

  data() {
    return {
      headers: headers,
      formatDate: catalogDate,
      formatMoney: catalogMonetary,
      logoAsaas,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'partners']),
  },

  methods: {
    ...mapActions(['fetchPartners', 'fetchPartner', 'handleOpenCreateEditPartnerModal', 'handleDeletePartnerModal']),
    ...mapMutations(['setIsDrawerOpen']),

    showPartner(id) {
      this.setIsDrawerOpen(true)
      this.fetchPartner(id)
    },

    showPartnerRow(_, { item }) {
      this.showPartner(item?.id)
    },
  },
}
</script>

<style scoped>
  .asaas {
    display: block;
    width: 22px;
    height: 22px;
    margin: 0 auto;
    border-radius: 50%;
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center 2px;
    background-color: #fff;
    box-shadow: 0 0 0 5px #fff;
  }

  .asaas.linked {
    background-position: center -32px;
  }
  </style>
